import { z } from "zod";
import { EventParticipantIdPublicSchema } from "./branded-id.schemas.js";
import {
  IntroRequestStatusSchema,
  INTRO_REQUEST_TYPE,
} from "./intro-request-state.schemas.js";
import { statusHistoryEntrySchema } from "./status-history.schemas.js";
import {
  IntroOriginSchema,
  IntroOriginDataSchema,
} from "./intro-origin.schemas.js";
import type { LocalizedText } from "./localized-text.schemas.js";

const _introRequestCreatableSchema = z.object({
  type: z.literal(INTRO_REQUEST_TYPE),
  origin: IntroOriginSchema,
  originData: IntroOriginDataSchema.nullable(),
  message: z.custom<LocalizedText | null>(),
  targetParticipantIdPublic: EventParticipantIdPublicSchema,
});

export const IntroRequestCreatableSchema =
  _introRequestCreatableSchema.readonly();

const _introRequestSchema = _introRequestCreatableSchema.extend({
  requesterParticipantIdPublic: EventParticipantIdPublicSchema,
  status: IntroRequestStatusSchema,
  statusHistory: z
    .array(statusHistoryEntrySchema(IntroRequestStatusSchema))
    .readonly(),
});

export const IntroRequestSchema = _introRequestSchema.readonly();

export type IntroRequestCreatable = z.infer<typeof IntroRequestCreatableSchema>;

export type IntroRequest = z.infer<typeof IntroRequestSchema>;
